let youtubeAPI;

function loadYoutubeAPI() {
	if (window.YT?.Player) return Promise.resolve(window.YT);
	if (youtubeAPI) return youtubeAPI;

	youtubeAPI = new Promise((resolve) => {
		const previousCallback = window.onYouTubeIframeAPIReady;

		window.onYouTubeIframeAPIReady = () => {
			if (typeof previousCallback === 'function') previousCallback();
			resolve(window.YT);
		};

		if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
			const script = document.createElement('script');
			script.src = 'https://www.youtube.com/iframe_api';
			document.head.appendChild(script);
		}
	});

	return youtubeAPI;
}

export async function initYoutubeVolumeControl() {
	const container = document.querySelector('#youtube-container');
	const iframe = container?.querySelector('#youtube-player');
	const control = container?.querySelector('.youtube-volume-control');
	const playButton = control?.querySelector('.youtube-play-button');
	const button = control?.querySelector('.youtube-volume-button');
	const slider = control?.querySelector('.youtube-volume-slider');

	if (!iframe || !control || !playButton || !button || !slider) return;

	const YT = await loadYoutubeAPI();
	let playerReady = false;
	let hideControlsTimer;
	const isTouchDevice = window.matchMedia('(hover: none)');

	const player = new YT.Player(iframe, {
		events: {
				onReady(event) {
					playerReady = true;
					event.target.setVolume(Number(slider.value));
					event.target.mute();
					updateControl(true);
					updatePlaybackControl(event.target.getPlayerState() === YT.PlayerState.PLAYING);
				},
				onStateChange(event) {
					updatePlaybackControl(event.data === YT.PlayerState.PLAYING);
				}
			}
		});

	function updatePlaybackControl(isPlaying) {
		control.classList.toggle('is-playing', isPlaying);
		playButton.setAttribute('aria-label', isPlaying ? '暫停影片' : '播放影片');
	}

	function updateControl(isMuted) {
		control.classList.toggle('is-muted', isMuted);
		button.setAttribute('aria-label', isMuted ? '開啟聲音' : '靜音');
	}

	function showTouchControls() {
		if (!isTouchDevice.matches) return;

		container.classList.add('is-controls-visible');
		clearTimeout(hideControlsTimer);
		hideControlsTimer = setTimeout(() => {
			container.classList.remove('is-controls-visible');
		}, 5000);
	}

	container.addEventListener('pointerdown', showTouchControls);

	playButton.addEventListener('click', () => {
		showTouchControls();
		if (!playerReady) return;

		if (player.getPlayerState() === YT.PlayerState.PLAYING) {
			player.pauseVideo();
			return;
		}

		player.playVideo();
	});

	button.addEventListener('click', () => {
		showTouchControls();
		if (!playerReady) return;

		if (player.isMuted() || player.getVolume() === 0) {
			if (Number(slider.value) === 0) slider.value = '50';
			player.setVolume(Number(slider.value));
			player.unMute();
			updateControl(false);
			return;
		}

		player.mute();
		updateControl(true);
	});

	slider.addEventListener('input', () => {
		showTouchControls();
		if (!playerReady) return;

		const volume = Number(slider.value);
		player.setVolume(volume);

		if (volume === 0) {
			player.mute();
			updateControl(true);
			return;
		}

		player.unMute();
		updateControl(false);
	});
}
